<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
</script>

<div class="fizz-flex-row" class:fizz-stack-4={$LayoutStore.isMobile}>
  <span class="fizz-badge fizz-surface-red fizz-flex-row-inline">
    <span class="fizz-inline-4">
      <Icon type="Error" extraClassNames="fizz-icon-16 fizz-text-negative" height="16" width="16" />
    </span>
    <span>Action Required</span>
  </span>
</div>
